import React, { useCallback, useContext, useMemo } from "react";
import netflixLogo from "assets/boost/bill-item-netflix.png";
import spotifyLogo from "assets/boost/bill-item-spotify.png";
import attLogo from "assets/boost/bill-item-att.png";
import moreLogo from "assets/boost/bill-item-more.png";
import { BreakpointContext } from "components/common";
import BankAccountList from "./BankAccountList/BankAccountList";
import TransactionTable from "./TransactionTable";

const LOGOS = [
  {
    src: netflixLogo,
    alt: "netflix",
  },
  {
    src: spotifyLogo,
    alt: "spotify",
  },
  {
    src: attLogo,
    alt: "att",
  },
  {
    src: moreLogo,
    alt: "more",
  },
];

export const NoAccounts = ({ className = "mt-12 px-6" }) => {
  const { isBelow } = useContext(BreakpointContext);
  const isBelowSm = isBelow("sm");
  const iconSize = isBelowSm ? "w-8 h-8" : "w-12 h-12";

  const renderLogo = useCallback(
    ({ src, alt }) => (
      <img
        key={alt}
        className={`${iconSize} rounded-full`}
        src={src}
        alt={alt}
        style={{ mixBlendMode: "luminosity" }}
      />
    ),
    [],
  );

  return (
    <div className={`flex flex-col h-full w-full justify-center items-center ${className}`}>
      <div className="flex space-x-5 md:space-x-8">{LOGOS.map(renderLogo)}</div>
      <p className="text-2xl font-bold mt-6">No accounts linked</p>
      <p
        className="text-base font-normal mt-3 text-center"
        style={{ maxWidth: 387, letterSpacing: 0.1, lineHeight: "150%" }}
      >
        Add you bank account or credit cards and we will automatically detect
        and track bills like rent, utilities, gym membership, insurance,
        streaming services.
      </p>
    </div>
  );
};

export const BillHistory = ({
  AddAccountComponent,
  accounts = [],
  transactions = [],
  setShowSelfAdd,
}) => {
  const numberOfAccounts = accounts.length;

  const sortedTransactions = useMemo(
    () =>
      transactions.sort((a, b) => {
        return (
          (b.posted_date ? new Date(b.posted_date).getTime() : 0) -
          (a.posted_date ? new Date(a.posted_date).getTime() : 0)
        );
      }),
    [transactions],
  );

  return (
    <div className="sm:h-full bg-white rounded shadow pt-8 pb-0 sm:pb-8">
      <div className="px-8">
        <div className="flex justify-between">
          <p className="font-bold text-2xl">Your Bills</p>
          <div className="invisible mdl:visible">
            {AddAccountComponent}
          </div>
        </div>
        <p className="text-base font-normal">Bills boost your credit.</p>
      </div>
      <div className="h-full flex flex-col">
        {numberOfAccounts === 0 ? (
          <>
            <NoAccounts />
            <div className="my-6 self-center visible mdl:invisible px-8 xs:px-12 sm:px-20 md:px-24">
              {AddAccountComponent}
            </div>
          </>
        ) : (
          <>
            <div className="px-8 mt-4 mb-6">
              <BankAccountList accounts={accounts} />
            </div>
            <div
              style={{ height: 1, width: "100%", backgroundColor: "#DBDBDB" }}
            />
            <div className="px-8 mt-6">
              <TransactionTable
                transactions={sortedTransactions}
                setShowSelfAdd={setShowSelfAdd}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
